var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import config from '../config';
import { saveAuthLetterStorageRef } from './accounts';
import { CardApiClient } from './cardApiClient';
var filesUrls = {
    getAuthLetterUploadLink: '/v2/files/upload_authorization_letter_link',
    getAuthorizationLetter: '/v2/accounts/authorization_letter',
    uploadLink: '/v2/files/upload_link'
};
var s3Client = axios.create({
    transformRequest: [
        function (data) {
            if (data && data.get && data.get('x-amz-credential')) {
                return data;
            }
            return JSON.stringify(data);
        }
    ],
    headers: {
        Accept: 'application/json'
    }
});
export function getAuthLetterUploadUrl(infoProvider, fileName) {
    return CardApiClient.post(filesUrls.getAuthLetterUploadLink, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        info_provider: infoProvider,
        filename: fileName
    }).then(function (response) { return response.data; });
}
export var uploadToS3 = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
uploadInfo, file, onProgress) {
    var formData = new FormData();
    var filename = file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    formData.append('key', uploadInfo.key);
    formData.append('x-amz-credential', uploadInfo['x-amz-credential']);
    formData.append('x-amz-date', uploadInfo['x-amz-date']);
    formData.append('x-amz-signature', uploadInfo['x-amz-signature']);
    formData.append('x-amz-algorithm', uploadInfo['x-amz-algorithm']);
    formData.append('acl', uploadInfo.acl);
    if (uploadInfo['x-amz-security-token']) {
        formData.append('x-amz-security-token', uploadInfo['x-amz-security-token']);
    }
    formData.append('policy', uploadInfo.policy);
    formData.append('Expires', uploadInfo['Expires']);
    formData.append('Content-Type', uploadInfo['Content-Type'] || 'multipart/form-data');
    formData.append('file', file);
    return s3Client
        .post(uploadInfo.url, formData, {
        headers: {
            'Content-Type': uploadInfo['Content-Type'],
            'Content-Disposition': "attachment; filename=" + filename
        },
        onUploadProgress: function (progressEvent) {
            if (onProgress) {
                onProgress(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
            }
        }
    })
        .then(function () {
        return uploadInfo.key;
    });
};
export function uploadAuthorizationLetter(file, infoProvider, onProgress) {
    return __awaiter(this, void 0, void 0, function () {
        var uploadInfo, storageRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAuthLetterUploadUrl(infoProvider, file.name)];
                case 1:
                    uploadInfo = _a.sent();
                    return [4 /*yield*/, uploadToS3(uploadInfo, file, onProgress)];
                case 2:
                    storageRef = _a.sent();
                    return [4 /*yield*/, saveAuthLetterStorageRef(storageRef)];
                case 3:
                    _a.sent();
                    return [2 /*return*/, storageRef];
            }
        });
    });
}
/* eslint-disable @typescript-eslint/camelcase */
export function getAuthLetterUrl(date, userName, shopName, rucNumber) {
    var qs = Object.entries({
        date: date ? date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() : '',
        user_name: userName,
        shop_name: shopName,
        ruc_number: rucNumber
    })
        .filter(function (_a) {
        var value = _a[1];
        return !!value;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return key + "=" + value;
    })
        .join('&');
    return config.apiUrl + "/" + filesUrls.getAuthorizationLetter + "?" + qs;
}
export function getManualUploadUrl(infoProvider, fileName, documentType) {
    return CardApiClient.post(filesUrls.uploadLink, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        document_type: documentType,
        filename: fileName,
        // eslint-disable-next-line @typescript-eslint/camelcase
        info_provider: infoProvider
    }).then(function (response) { return response.data; });
}
